import { gql } from '@apollo/client'

export const ESTIMATE_ONE_TIME_PAYMENT = gql`
  query estimateOneTimePayment($purchasableItems: [PurchasableItem!]!) {
    estimateOneTimePayment(purchasableItems: $purchasableItems) {
      price
      discount
      total
    }
  }
`
